import { keycloak } from '../config/keycloak';
import { domain } from '../config/environment';


const api = async ({ url, method = 'get', query, body }) => {
	let options = {
		method: method,
		mode: 'cors',
		headers: {
			'Authorization': `${keycloak.token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	};
	let req = new URL(`${domain}${url}`);
	if (query) req.search = new URLSearchParams(query);
	return fetch(req, options);
}

export const apifileupload = async ({ url, method = 'get', query, body }) => {
	let options = {
		method: method,
		mode: 'cors',
		headers: {
			'Authorization': `${keycloak.token}`
		},
		body: body,
	};
	let req = new URL(`${domain}${url}`);
	if (query) req.search = new URLSearchParams(query);
	return fetch(req, options);
}

export default api;